import React, { useState, useEffect } from "react";
import {
  Table,
  Text,
  Thead,
  Box,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  Breadcrumb,
  BreadcrumbItem,
  Flex,
  BreadcrumbLink,
  Link,
} from "@chakra-ui/react";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import JSONPretty from "react-json-pretty";
import { getFormSubmission } from "../../api/formSubmissionApi";
const SubmissionView = ({ submissionId, onRedirectHandler }) => {
  const [data, setData] = useState({});
  const getKeyValueMarkup = () => {
    return Object.keys(data)
      .filter((key) => {
        return !["formId", "ID", "filter"].includes(key);
      })
      .map((key, index) => {
        if (key == "address") {
          return (
            <tr>
              <Td key={index}>{key}</Td>
              <Td key={key + index}>
                <Box>
                  <Text>
                    {data.address["addressLine1"]}{" "}
                    {data.address["addressLine2"]}
                    {data.address["state"]} {data.address["city"]}{" "}
                    {data.address["country"]}
                    {data.address["zipCode"]}
                  </Text>
                </Box>
              </Td>
            </tr>
          );
        }
        return (
          <>
            <tr>
              <Td key={index}>{key}</Td>
              <Td key={key + index}>
                {data[key].length ? (
                  <JSONPretty id="json-pretty" data={data[key]} />
                ) : (
                  ""
                )}
              </Td>
            </tr>
          </>
        );
      });
  };
  const renderTableBody = () => {
    return <>{getKeyValueMarkup()}</>;
  };
  useEffect(() => {
    getFormSubmission(submissionId).then((response) => {
      console.log("=============?Submission", response);

      var response2 = JSON.stringify(response).replaceAll(
        /[A-Za-z]+\.[0-9]+\./gi,
        function () {
          return "";
        }
      );
      var response3 = JSON.parse(response2);
      setData(response3);
    });
  }, [submissionId]);
  return (
    <Box>
      <Breadcrumb m="1rem 0">
        <BreadcrumbItem fontSize="14px">
          <Flex align="center">
            <ChevronLeftIcon color="blue" />
            <BreadcrumbLink ml="2" color="blue" href="#">
              <Link color="blue" onClick={onRedirectHandler}>
                Back
              </Link>
            </BreadcrumbLink>
          </Flex>
        </BreadcrumbItem>
      </Breadcrumb>
      <Box bg="#fff">
        <Table variant="simple">
          {/* <TableCaption>{template.title}</TableCaption> */}
          <Thead>
            <Tr>
              <Th>Key</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>{renderTableBody()}</Tbody>
          <Tfoot>
            <Tr>
              <Th>Key</Th>
              <Th>Value</Th>
            </Tr>
          </Tfoot>
        </Table>
      </Box>
    </Box>
  );
};

export default SubmissionView;
